import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import EditorialMarquee from "@/components/site/EditorialMarquee";
import Courses from "@/components/site/Courses";
import Manifesto from "@/components/site/Manifesto";
import Testimonials from "@/components/site/Testimonials";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import WhatsAppButton from "@/components/site/WhatsAppButton";

export default function Home() {
  return (
    <div className="bg-background min-h-screen" data-testid="home-page">
      <Navbar />
      <Hero />
      <EditorialMarquee />
      <Courses />
      <Manifesto />
      <Testimonials />
      <Contact />
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
